import React from "react";

const ContactUsSection = () => {
  return (
    <section
      className="section section-soft contact-preview-section"
      id="contact-form"
    >
      <div className="container">
        <div className="split-grid">
          <div>
            <p className="eyebrow">Contact Us</p>
            <h2>Let us get in touch.</h2>
            <p>
              Tell us what you need help with. The team can route career
              consultations, technical questions, tracking issues, and general
              inquiries.
            </p>
            <p className="contact-line">hr@lovapextech.com</p>
          </div>
          <form className="card form-card">
            <label className="field">
              <span className="field-label">Full Name</span>
              <input placeholder="Your name" type="text" />
            </label>
            <label className="field">
              <span className="field-label">Email Address</span>
              <input placeholder="you@example.com" type="email" />
            </label>
            <label className="field">
              <span className="field-label">Enquiry</span>
              <select>
                <option value="General Inquiry">General Inquiry</option>
                <option value="Technical Issue">Technical Issue</option>
                <option value="Career Consultation">Career Consultation</option>
                <option value="Tracking Issue">Tracking Issue</option>
              </select>
            </label>
            <label className="field">
              <span className="field-label">Message</span>
              <textarea placeholder="How can we help?"></textarea>
            </label>
            <label className="checkbox-field">
              <input type="checkbox" />
              <span>I agree to the Privacy Policy</span>
            </label>
            <button className="button button-primary button-md" type="button">
              Submit Form
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUsSection;
